import { Link } from "react-router-dom";
import type { MovieItem } from "@/mocks/movies";

interface MovieCardProps {
  movie: MovieItem;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      aria-label={movie.title}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} 秋霞网影视资源`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950 via-secondary-950/30 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300" />

        <span className="absolute top-2 left-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-foreground-950">
          {movie.type === "movie" ? "电影" : "电视剧"}
        </span>

        <span className="absolute top-2 right-2 flex items-center gap-1 rounded-md bg-secondary-950/80 px-2 py-0.5 text-xs font-semibold text-accent-400">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>

        {typeof rank === "number" && (
          <span className="absolute bottom-0 left-1 font-heading text-5xl font-black leading-none text-foreground-950/90 drop-shadow">
            {rank}
          </span>
        )}

        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-foreground-950">
            <i className="ri-play-fill text-2xl" />
          </span>
        </span>

        {movie.type === "tv" && (
          <span className="absolute bottom-2 right-2 rounded-md bg-secondary-950/80 px-2 py-0.5 text-xs text-foreground-800">
            全 {movie.episodes} 集
          </span>
        )}
      </div>

      <h3 className="mt-2 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-500">
        {movie.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">
        {movie.year} · {movie.genres.slice(0, 2).join(" ")}
      </p>
    </Link>
  );
}